import avatar from '../static/other/avatar.svg';
import clsx from 'clsx';

function UserAvatar(props) {
  return <img
    onError={event => {
      // Fall back once; if the fallback fails too, stop instead of looping
      if (event.currentTarget.getAttribute("src") !== avatar) event.currentTarget.src = avatar;
    }}
    src={props.src || (props.user_id ? "https://api.sort-me.org/getUserAvatar?id=" + props.user_id : avatar)}
    alt="avatar"
    id={props.id || undefined}
    className={clsx("user-avatar", props.className)}
    width={props.size}
    height={props.size}
  />;
}

export default UserAvatar;
